/**
 * Returns the total count of cart.products quantity for all carts
 *
 * @param {Array} carts - list of cart objects
 * @return {Number} Total sum of cart.products quantity for all carts
 */
export default function getCartCount(carts=[]) {
	return carts.reduce((total, cart) => {
		return total + cart.products.reduce((qty, cp) => qty + cp.quantity, 0);
	}, 0);
}
